module.exports = __webpack_public_path__ + "static/weather-column-thumb-67c04dc851d5a47175842385e3856044.png";